<div style="display: block;" id="containerCompleto">
    <div id="titulo">
      <h2 style="padding-left: 10px">Buscar peticiones</h2>
      <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
    </div>

    <div  style="display: flex;">
        <div class="campo">
            <mat-select style="min-width: 0;width: 100%;" [(ngModel)]="this.cia" >
                <mat-option *ngFor="let opt of this.listadoCias" [value]="opt">{{opt}}</mat-option>
            </mat-select>
        </div>
    </div>
        <!--este boton es el que se  encarga DE actualizar los datos en BD-->
    <div *ngIf="this.cia == 'TUVOZ'" style="display: flex; gap: 10px;justify-content: flex-end;">
        <a class="btnCCOscuro" mat-flat-button style="width:100%;" (click) = "actualizarCia()">Actualizar</a>
    </div>

    <div style="display: flex;gap: 10px;margin-top:20px;">
        <div class="campo">
            <label>ID</label>
            <input type="text"matInput [(ngModel)]="this.id" >
        </div>
        <div *ngIf="this.cia != 'CORREDORES' && this.cia != 'REPARABRISAS RLS'" class="campo">
            <label>Estado</label>
            <mat-select style="display:block;min-width: 0;width: 100%;" [(ngModel)]="this.estado">
                <mat-option [value]="0">0 - Pendientes</mat-option>
                <mat-option [value]="1">1 - Gestionadas</mat-option>
                <mat-option [value]="2">2 - Rellamadas</mat-option>
                <mat-option [value]="5">*** TODAS ***</mat-option>
            </mat-select>
        </div>
        <div *ngIf="this.cia == 'CORREDORES' || this.cia == 'REPARABRISAS RLS'" class="campo">
          <label>Estado</label>
          <mat-select style="display:block;min-width: 0;width: 100%;" [(ngModel)]="this.estado">
            <mat-option [value]="0">0 - Pendientes</mat-option>
            <mat-option [value]="1">1 - Gestionadas</mat-option>
            <mat-option [value]="2">2 - Completadas</mat-option>
            <mat-option [value]="3">3 - Anuladas</mat-option>
            <mat-option [value]="4">4 - Rellamadas</mat-option>
            <mat-option [value]="5">*** TODAS ***</mat-option>
          </mat-select>
        </div>
    </div>
    <div style="display: flex;gap: 10px;">
        <div class="campo">
            <label>Fecha Inicio</label>
            <!--<input type="text"matInput>-->
            <input matInput [matDatepicker]="fInicio" (click)="fInicio.open()" [(ngModel)]="this.fechaInicio" >
            <mat-datepicker #fInicio></mat-datepicker>
        </div>
        <div class="campo">
            <label>Fecha Fin</label>
            <input matInput [matDatepicker]="fFin" (click)="fFin.open()" [(ngModel)]="this.fechaFin" >
            <mat-datepicker #fFin></mat-datepicker>
        </div>
    </div>

    <div style="display: flex;gap: 10px;">
        <div class="campo">
            <label>Matrícula</label>
            <input type="text" matInput [(ngModel)]="this.matricula">
        </div>
    </div>
    <div style="display: flex;gap: 10px; margin-top:20px;">
        <a class="btnCCOscuro" mat-flat-button style="width:100%" (click)="onClose()" >Cancelar</a>
        <a  [class.btnCCNewOscuro]="!buscarDeshabilitado()"
            mat-flat-button
            style="width:100%"
            (click)="cargarDialogPeticiones()"
            [disabled]="buscarDeshabilitado()"
            [ngClass]="{ 'disabled-button': buscarDeshabilitado() }"
            >Buscar</a>
    </div>
</div>
